export default 'https://vcrete-devn.soscuisine.com';
